import React, { useState, useRef } from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import '../css/StockMetrics.css'; // Ensure you have this CSS file for styling

const StockChartPattern = ({ stockInfo }) => {
  
  const [isWatching, setIsWatching] = useState(false);
  const [hasAlerts, setHasAlerts] = useState(false);

  console.log("Stock Chart Patterns:", stockInfo.chartPatterns);
  console.log("patterns:", stockInfo.chartPatterns.headAndShoulders.detected);
    // Add safety check at the very beginning
  if (!stockInfo) {
    return (
      <div className="stock-header-container">
        <div className="loading">Loading stock information...</div>
      </div>
    );
  }
    const chartPatterns = [
    {
      label: "Head and Shoulders",
      detected: `${stockInfo.chartPatterns.headAndShoulders.detected}`,
      confidence: `${stockInfo.chartPatterns.headAndShoulders.confidence}`, // Example pattern
      neckline: `${stockInfo.chartPatterns.headAndShoulders.neckline}`, // Example pattern
      target: `${stockInfo.chartPatterns.headAndShoulders.target}` // Example pattern
    },
    {
      label: "Double Top",
      detected: `${stockInfo.chartPatterns.doubleTop.detected}`,
      confidence: `${stockInfo.chartPatterns.doubleTop.confidence}`,
      breakdown: `${stockInfo.chartPatterns.doubleTop.breakdown_level}`, // Example pattern
      target: `${stockInfo.chartPatterns.doubleTop.target}` // Example pattern
    },
    {
      label: "Double Bottom",
      detected: `${stockInfo.chartPatterns.doubleBottom.detected}`,
      confidence: `${stockInfo.chartPatterns.doubleBottom.confidence}`,
      breakout: `${stockInfo.chartPatterns.doubleBottom.breakout_level}`, // Example pattern
      target: `${stockInfo.chartPatterns.doubleBottom.target}` // Example pattern
    },
    {
      label: "Ascending Triangle",
      detected: `${stockInfo.chartPatterns.ascendingTriangle.detected}`,
      confidence: `${stockInfo.chartPatterns.ascendingTriangle.confidence}`,
      resistance: `${stockInfo.chartPatterns.ascendingTriangle.resistance}`,
      target: `${stockInfo.chartPatterns.ascendingTriangle.breakout_target}`
    },
    // {
    //   label: "Descending Triangle",
    //   detected: `${stockInfo.chartPatterns.descendingTriangle.detected}`,
    //   confidence: `${stockInfo.chartPatterns.descendingTriangle.confidence}`,
    //   support: `${stockInfo.chartPatterns.descendingTriangle.support}`,
    //   target: `${stockInfo.chartPatterns.descendingTriangle.breakdown_target}`
    // },
    {
      label: "Symmetrical Triangle",
      detected: `${stockInfo.chartPatterns.symmetricalTriangle.detected}`,
      confidence: `${stockInfo.chartPatterns.symmetricalTriangle.confidence}`,
      target: `${stockInfo.chartPatterns.symmetricalTriangle.target}`
    },
    {
      label: "Bull Flag",
      detected: `${stockInfo.chartPatterns.bullFlag.detected}`,
      confidence: `${stockInfo.chartPatterns.bullFlag.confidence}`,
      target: `${stockInfo.chartPatterns.bullFlag.target}`
    },
    {
      label: "Bear Flag",
      detected: `${stockInfo.chartPatterns.bearFlag.detected}`,
      confidence: `${stockInfo.chartPatterns.bearFlag.confidence}`,
      target: `${stockInfo.chartPatterns.bearFlag.target}`
    },
    {
      label: "Cup and Handle",
      detected: `${stockInfo.chartPatterns.cupAndHandle.detected}`,
      confidence: `${stockInfo.chartPatterns.cupAndHandle.confidence}`,
      target: `${stockInfo.chartPatterns.cupAndHandle.target}`
    }
    // {
    //   label: "MACrossover",
    //   detected: `$${stockInfo.chartPatterns.ma_crossover.detected}`,
    //   confidence: `${stockInfo.chartPatterns.ma_crossover.confidence}`,
    //   target: `$${stockInfo.chartPatterns.ma_crossover.target}`
    // },
    // {
    //   label: "Hammer",
    //   detected: `$${stockInfo.chartPatterns.hammer.detected}`,
    //   confidence: `${stockInfo.chartPatterns.hammer.confidence}`,
    //   target: `$${stockInfo.chartPatterns.hammer.target}`
    // },
    // {
    //   label: "Shooting Star",
    //   detected: `$${stockInfo.chartPatterns.shooting_star.detected}`,
    //   confidence: `${stockInfo.chartPatterns.shooting_star.confidence}`,
    //   target: `$${stockInfo.chartPatterns.shooting_star.target}`
    // },
    // {
    //   label: "Harami",
    //   detected: `$${stockInfo.chartPatterns.harami.detected}`,
    //   confidence: `${stockInfo.chartPatterns.harami.confidence}`,
    //   target: `$${stockInfo.chartPatterns.harami.target}`
    // },
    // {
    //   label: "Doji Star",
    //   detected: `$${stockInfo.chartPatterns.doji_star.detected}`,
    //   confidence: `${stockInfo.chartPatterns.doji_star.confidence}`,
    //   target: `$${stockInfo.chartPatterns.doji_star.target}`
    // },
    // {
    //   label: "Morning Star",
    //   detected: `$${stockInfo.chartPatterns.morning_star.detected}`,
    //   confidence: `${stockInfo.chartPatterns.morning_star.confidence}`,
    //   target: `$${stockInfo.chartPatterns.morning_star.target}`
    // },
    // {
    //   label: "Evening Star",
    //   detected: `$${stockInfo.chartPatterns.evening_star.detected}`,
    //   confidence: `${stockInfo.chartPatterns.evening_star.confidence}`,
    //   target: `$${stockInfo.chartPatterns.evening_star.target}`
    // },
    // {
    //   label: "Engulfing Bullish",
    //   detected: `$${stockInfo.chartPatterns.engulfing_bullish.detected}`,
    //   confidence: `${stockInfo.chartPatterns.engulfing_bullish.confidence}`,
    //   target: `$${stockInfo.chartPatterns.engulfing_bullish.target}`
    // }

  ];

  return (

            <section className="patterns-section">
                <h3>Chart Patterns</h3>
                <div className="patterns-list">
                {chartPatterns.map((pattern, index) => (
                    <div className="pattern-item" key={index}>
                    <span className="pattern-name">{pattern.label} : </span>
                    <span className="pattern-confidence high"> {pattern.confidence}</span>
                    <span className={`pattern-building ${pattern.target}`}>
                        {pattern.target}
                    </span>
                    {/* {indicators.change !== null && (
                        <span className={`metric-change ${indicators.change >= 0 ? 'positive' : 'negative'}`}>
                        {indicators.change >= 0 ? <FaArrowUp /> : <FaArrowDown />}
                        {Math.abs(indicators.change)}%
                        </span>
                    )} */}
                    </div>
                ))}
                </div>
            </section>            

  );
};

export default StockChartPattern;